/*
 * @Auther: 罗耀祖
 * @Date: 2022-03-17 15:06:24
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-17 15:09:49
 * @name: 通用模块服务
 * @Description: 通用模块服务
 * @FilePath: \project\src\module\common\common.service.js
 * @Author: desktop
 */
import commonController from "./common.controller";
import { confirmation } from "@/utils/decorator";
const commonService = class {
	constructor() {
		this.commonController = new commonController();
		this.sms_countdown = 60; //短信倒计时
	}
	sendVerificationCode(req) {
		return new Promise((resolve, reject) => {
			this.commonController.verify(req).then((ctx) => {
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
	getUploadStsToken(req) {
		return new Promise((resolve, reject) => {
			this.commonController.getUploadStsToken(req).then((ctx) => {
				resolve(ctx.response);
			}).catch((ctx) => {
				reject(ctx.response);
			});
		})
	}
}
export default commonService;